import { IPasswordTypeUIDetails } from '@app/models';

export const getPasswordTypeUIDetails = (passwordType: string): IPasswordTypeUIDetails  => {
    let details: IPasswordTypeUIDetails = {} as IPasswordTypeUIDetails;

    switch (passwordType) {
        case 'AD_Windows':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_1';
            details.passwordTypeImage = 'icon__windows';
            break;
        case 'AuthAnvil_Related':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_2';
            details.passwordTypeImage = 'icon__security';
            break;
        case 'General':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_3';
            details.passwordTypeImage = 'icon__document';
            break;
        case 'Linux':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_4';
            details.passwordTypeImage = 'icon__linux';
            break;
        case 'Network_Device':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_5';
            details.passwordTypeImage = 'icon__move-item';
            break;
        case 'Remote_Windows':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_6';
            details.passwordTypeImage = 'icon__windows';
            break;
        case 'SNMP':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_7';
            details.passwordTypeImage = 'icon__network';
            break;
        case 'SNMPV3':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_12';
            details.passwordTypeImage = 'icon__network';
            break;
        case 'SSH':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_8';
            details.passwordTypeImage = 'icon__code';
            break;
        case 'Standalone_Windows':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_9';
            details.passwordTypeImage = 'icon__windows';
            break;
        case 'Web':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_10';
            details.passwordTypeImage = 'icon__web';
            break;
        case 'Database':
            details.passwordTypeForDisplay = 'VAULT_PASSWORD_TYPE_11';
            details.passwordTypeImage = 'icon__database';
            break;
    }

    return details;
};

export const hasMachineName = (passwordEnum: string) => {
    switch (passwordEnum) {
        case 'Standalone_Windows':
        case 'SSH':
        case 'Network_Device':
        case 'Remote_Windows':
        case 'Linux':
        case 'Database':
            return true;
        default:
            return false;
    }
};

export const showGenericCredentials = (passwordEnum: string) => {
    if (passwordEnum === 'SNMP' || passwordEnum === 'SNMPV3') {
        return false;
    }

    return true;
};

export const getShareablePasswordLink = (passwordId: string): string => {
    return `${window.location.origin}/sharepwd?id=${passwordId}`;
};